import { Alert, Snackbar } from "@mui/material";
import Feedback from "components/CustomerAccount/Feedback";
import React, { Component } from "react";
import { FeedbackApi } from "stores/Feedback/FeedbackApi";
function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class FeedbackContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusvalue: "successful",
      // open: false,
      page:0,
      limit:100,  
      drawerOpen: false,
      review: "",
      customerName: "",
      feedback_reply:"",
      date: "",
      time: "",
      replyText: "",
      cutomerId: "",
      messageReply: false,
      problemText: "",
      inputsearch:'',
      formData: {
        from_date: "",
        to_date: "",
      },
      modalMessage: {
        open: false,
        message: "",
      },
    };
    this.debouncedSearch = debounce(this.performSearch?.bind(this), 500);
  }
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({ inputsearch: query });
    this.debouncedSearch(query);
  };
  performSearch(searchQuery) {
    if (searchQuery) {
      this.props.FeedbackReducerDataAction({
        search_term: searchQuery,
        status: this.state.statusvalue,
        // page:this.state.page ,
        // limit:this.state.limit
      });
      return;
    } else this.props.FeedbackReducerDataAction({ status: this.state.statusvalue, limit: this.state.limit });
  }
  toggleDrawer = (data) => {
    if (data.id) {
      this.setState({ drawerOpen: true });
      this.setState({ review: data.review });
      this.setState({ customerName: data.customerName });
      this.setState({ feedback_reply: {reply:data.reply_to_feedback,time:data.replyTime} });
      this.setState({ date: data.date });
      this.setState({ time: data.time });
      this.setState({ cutomerId: data.id });
      this.setState({ problemText: data.problem });
    } else {
      this.setState({ drawerOpen: false });
    }
  };

  handleSnackbarClose = () => {
    this.setState({
      modalMessage: {
        open: false,
      },
    });
  };

  handleReplyOnChange = (e) => {
    this.setState({ replyText: e.target.value });
  };

  handleReplySubmit = async () => {
    try {
      const res = await FeedbackApi.FeedBackReplybyId({
        id: this.state.cutomerId,
        replyText: this.state.replyText,
      });

      if (res.message === "Feedback reply updated successfully") {
        this.setState({ messageReply: true, replyText: "",drawerOpen:false });
        this.setState({
          modalMessage: {
            open: true,
            message: res?.message,
          },
        });
    this.props.FeedbackReducerDataAction({ status:this.state.statusvalue,page:this.state.page ,limit:this.state.limit  });
      }
      if (res.message === "Feedback reply Already Added") {
        this.setState({
          modalMessage: {
            open: true,
            message: res?.message,
          },
        });
      }
    } catch (error) {
      console.error("Error submitting reply:", error);
    }
    this.setState({ replyText: "" });
  };

  handleTabChange = (e, newValue) => {
  
    this.setState({ statusvalue: newValue });
      this.props.FeedbackReducerDataAction({ status:newValue,page:this.state.page ,limit:this.state.limit   });
  };

  componentDidMount() {
    this.props.FeedbackReducerDataAction({ status:this.state.statusvalue,page:this.state.page ,limit:this.state.limit  });
  }
  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });
    const payload = {
      status:this.state.statusvalue,
      search_term: this.state.inputsearch,
      limit: rowsPerPage,
      page: page,
      
    };
    this.props.FeedbackReducerDataAction(payload);
  };
  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };

  handleFilterApiData = async () => {
    await this.props.FeedbackReducerDataAction({
      status:this.state.statusvalue,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      page: this.state.page,
      limit: this.state.limit,
    });
  };
  handleReset = async () =>{
    await this.props.FeedbackReducerDataAction({
      status:this.state.statusvalue,
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      page: this.state.page,
      limit: 100,
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }
  render() {

    return (
      <div>
        <Feedback
        totalCount={this.props.FeedbackList?.pagination?.totalCount}
          handleTabChange={this.handleTabChange}
          value={this.state.statusvalue}
          toggleDrawer={this.toggleDrawer}
          drawerOpen={this.state.drawerOpen}
          data={this.props.FeedbackList}
          review={this.state?.review}
          customerName={this.state?.customerName}
          feedback_reply={this.state?.feedback_reply}
          date={this.state?.date}
          status={this.state.statusvalue}
          page={this.state.page}
          limit={this.state.limit}
          time={this.state?.time}
          handleReplyOnChange={this.handleReplyOnChange}
          handleReplySubmit={this.handleReplySubmit}
          messageReply={this.state.messageReply}
          problemText={this.state.problemText}
          replyText={this.state.replyText}
          isLoading={this.props.isLoading}
          searchhandleChange={this.searchhandleChange}
          onPageChange={this.onPageChange}
          onDatePickerSub={this.onDatePickerSub}
          onChange={this.handleChange}
          datePickerOpen={this.state.datePickerOpen}
          handleDatePickerOpen={this.handleDatePickerOpen}
          handleDatePickerClose={this.handleDatePickerClose}
          from_date={this.state.formData.from_date}
          to_date={this.state.formData.to_date}
          fromat_date_from={this.state.formData.fromat_date_from}
          fromat_date_to={this.state.formData.fromat_date_to}
          handleReset={this.handleReset}
        />

        <Snackbar
          open={this.state.modalMessage.open}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
          message={this.state.modalMessage.message}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          {this.state.modalMessage.message ===
          "Feedback reply updated successfully" ? (
            <Alert severity="success">{this.state.modalMessage.message}</Alert>
          ) : (
            <Alert severity="warning">{this.state.modalMessage.message}</Alert>
          )}
        </Snackbar>
      </div>
    );
  }
}
